export function validateContactForm(values) {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!values.first_name?.trim())
        errors.first_name = "First name is required";

    if (!values.last_name?.trim())
        errors.last_name = "Last name is required";

    if (!values.email?.trim())
        errors.email = "Email is required";
    else if (!emailRegex.test(values.email))
        errors.email = "Enter a valid email";

    if (!values.mobile?.trim())
        errors.mobile = "Phone number is required";
    else if (!phoneRegex.test(values.mobile))
        errors.mobile = "Enter a valid 10-digit number";

    if (!values.category)
        errors.category = "Please select a category";

    if (!values.message?.trim())
        errors.message = "Message cannot be empty";

    return errors;
}
